<footer class="footer">

    <!-- Copyright -->
    <div class="footer-copyright text-center py-3">Copyright © 2018 by
        <a href="https://risc-software.at/">RISC Software GmbH</a>
    </div>
    <!-- Copyright -->

</footer>
